import { render, staticRenderFns } from "./LandingSection.vue?vue&type=template&id=3e7c1b62&scoped=true&"
import script from "./LandingSection.vue?vue&type=script&lang=js&"
export * from "./LandingSection.vue?vue&type=script&lang=js&"
import style0 from "./LandingSection.vue?vue&type=style&index=0&id=3e7c1b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c1b62",
  null
  
)

export default component.exports